@if (showLoader) {
  <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
}
@if (!showLoader) {
  <app-documents #documents [downloadAdditionalDocsInput]="downloadAdditionalDocs" [weavyData]="weavyData"
  [docType]="'referral'"></app-documents>
}